"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationCode = void 0;
var GlobalErrorCode;
(function (GlobalErrorCode) {
    GlobalErrorCode[GlobalErrorCode["HTTP_REQUEST_ERROR"] = 1] = "HTTP_REQUEST_ERROR";
    GlobalErrorCode[GlobalErrorCode["HTTP_UNAUTHORIZE_RERROR"] = 401] = "HTTP_UNAUTHORIZE_RERROR";
})(GlobalErrorCode || (GlobalErrorCode = {}));
var OrganizationCode;
(function (OrganizationCode) {
    OrganizationCode["LOP"] = "lop";
    OrganizationCode["GMI"] = "gmi";
    OrganizationCode["WM"] = "wm";
    OrganizationCode["SAS"] = "sas";
    OrganizationCode["AS"] = "as";
})(OrganizationCode || (OrganizationCode = {}));
exports.OrganizationCode = OrganizationCode;
